<template>
    <form id="website-form" @submit.prevent="formController(url, $event)">
        <div class="form-group">
                            <label for="name">Company Name</label>
                            <input type="text" class="form-control" id="company" aria-describedby="emailHelp" placeholder="Enter company name">
                        </div>
                        <div class="form-group">
                            <label for="name">Address</label>
                            <input type="text" class="form-control" id="address" aria-describedby="emailHelp" placeholder="Address company or personal">
                        </div>
                        <div class="form-group">
                            <label for="name">City</label>
                            <input type="text" class="form-control" id="city" aria-describedby="emailHelp" placeholder="City company or personal">
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>COUNTRY</label>
                                    <select class="form-control" id="country" name="country" v-model="model.country">
                                        <option value="">-- Select --</option>
                                        <option v-for="country in countries" :value="country.name" v-bind:key="country.id">{{ country.name }}</option>
                                    </select>
                                    <div id="country-error" class="error invalid-feedback"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="name">State</label>
                                    <input type="text" class="form-control" id="state" aria-describedby="emailHelp" placeholder="State">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label for="name">Zip</label>
                                    <input type="text" class="form-control" id="zip" aria-describedby="emailHelp" placeholder="Zip">
                                </div>
                            </div>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input">
                            <label class="custom-control-label" for="customRadioInline1">Create Website</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input">
                            <label class="custom-control-label" for="customRadioInline2">Renew website</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="customRadioInline3" name="customRadioInline1" class="custom-control-input">
                            <label class="custom-control-label" for="customRadioInline3">Other</label>
                        </div>
                        <div class="form-group">
                            <label for="name">Message</label>
                            <textarea type="text" class="form-control" id="city" aria-describedby="emailHelp" placeholder="Message"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary btn-form-websites">Next</button>
    </form>
</template>

<script>
    import { EventBus } from '../EventBus';

    export default {
        props: {
            url: {
                type: String,
                default: ''
            },
            countries: {
                type: Array,
                default: function() {
                    return []
                }
            }
        },
        data() {
            return {
                model: {
                    business_name: '',
                    full_name: '',
                    email: '',
                    phone: '',
                    website: '',
                    message: '',
                    country: '',
                    request_types: [],
                },
                submitText: 'Send',
                successMessage: '',
            }
        },
        created() {
            this.clearModel();
        },
        methods: {
            clearModel: function() {
                this.model = {
                    business_name: '',
                    full_name: '',
                    email: '',
                    phone: '',
                    website: '',
                    message: '',
                    country: '',
                    request_types: [],
                }
            },
            formController: function(url, event) {
                var vm = this;

                $(event.target).find('button').attr('disabled', true);
                this.submitText = 'Sending...'

                var target = $(event.target);
                var url = url;
                var fd = new FormData(event.target);

                axios.post(url, fd, { headers: {
                        'Content-type': 'application/x-www-form-urlencoded',
                    }
                }).then(response => {
                    $(event.target).find('button').attr('disabled', false);
                    this.submitText = 'Send';
                    this.successMessage = 'Form submitted successfully.';
                    this.clearModel();
                }).catch(error => {
                    $(event.target).find('button').attr('disabled', false);
                    this.submitText = 'Send';
                    this.successMessage = 'There was an error while sending. Please try again.';

                    console.log(error.response);
                    var obj = error.response.data.errors;
                    $('#websites-form').animate({
                        scrollTop: 0
                    }, 500, 'swing');
                    $.each(obj, function(i, item) {
                        let c_target = target.find("#" + i + "-error");
                        if (!c_target.attr('data-required')) {
                            let p = c_target.prev();
                            p.addClass('is-invalid');
                        } else {
                            c_target.css('display', 'block');
                        }
                        c_target.html(item);
                    });
                });
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
